(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
    const forms = document.querySelectorAll('.footer-newsletter__form');

    for (const form of forms) {
      if (!(form instanceof HTMLFormElement) || form.dataset.privacyBound === 'true') continue;
      form.dataset.privacyBound = 'true';

      const checkbox = form.querySelector('.footer-newsletter__consent-input');
      const error = form.querySelector('.footer-newsletter__consent-error');
      if (!(checkbox instanceof HTMLInputElement) || !(error instanceof HTMLElement)) continue;

      const showError = () => {
        error.hidden = false;
        checkbox.setAttribute('aria-invalid', 'true');
      };

      const clearError = () => {
        error.hidden = true;
        checkbox.removeAttribute('aria-invalid');
      };

      checkbox.addEventListener('change', () => {
        if (checkbox.checked) clearError();
      });

      form.addEventListener('submit', (event) => {
        if (checkbox.checked) {
          clearError();
          return;
        }

        event.preventDefault();
        showError();
        checkbox.focus();
      });

      form.addEventListener('invalid', (event) => {
        if (event.target === checkbox) {
          showError();
        }
      }, true);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
